<template>
      <div >
        <v-switch
          inset
          color="#EEBB07"
          v-model="alert.enabled"
          dense
          hide-details
          class="mt-0 mb-3"
          @click="updateAlert(alert)"
        >
        <template v-slot:label>
        {{ $t("message.alert.quotationLabel", { value: "default" }) }}
      </template>
      </v-switch>
    </div>
    
</template>

<script>
import { mapGetters } from "vuex";
import TeamsService from "@/services/TeamsService.js";

export default {
  data() {
    return {
      alert: {}
    };
  },
  methods: {

    updateAlert(alert) {
      let payload = {
        enabled: alert.enabled,
        mail: this.getterContact.mail
      }
      TeamsService.saveQuotationAlert(alert.id, payload)
    },

    loadAlert() {      
      TeamsService.getQuotationSentAlert(this.getterContact.mail, this.getterCurrentClient).then(
        response => this.alert = response.data
        ).catch(() =>{
        this.alert = {
                enabled: false,
                mail: undefined
              }}
        );
        this.loading = false
    },
  },

  mounted() {
    this.loadAlert();
  },

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),
  },
};
</script>
<style scoped>
 

  .dp.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  color: #fff;
  font-size: 16px;
}

.theme--light.v-icon {
  color: #fff;
}

.dp.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:hover {
  color: #fff;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
</style>
